import { service } from '@ember/service';

import Base from 'ember-simple-auth/authenticators/base';
import md5 from 'md5';

export default class CustomAuthenticator extends Base {
  // Services
  @service currentUser;
  @service fetch;

  // Hooks
  async restore(data) {
    if (!data || !data.token) {
      return Promise.reject();
    }

    const currentUser = await this.currentUser.load({
      headers: { 'X-UMG-BACKEND-TOKEN': data?.token },
    });

    if (!currentUser) {
      throw new Error(this.intl.t('authenticator.microsoft.no_user'));
    }

    return data;
  }

  async authenticate(options) {
    let headers = {
      'X-UMG-USER': options.username,
      'X-UMG-PASSWORD': md5(options.password),
      'X-UMG-CREATED': 'now',
    };

    const { response, payload } = await this.fetch.raw('login', { headers });
    const currentUser = await this.currentUser.load({
      headers: {
        'X-UMG-BACKEND-TOKEN': response.headers.get('X-UMG-BACKEND-TOKEN'),
      },
    });

    if (!currentUser) {
      throw new Error(this.intl.t('authenticator.microsoft.no_user'));
    }

    return {
      userId: payload.userId,
      token: response.headers.get('X-UMG-BACKEND-TOKEN'),
    };
  }
}
